import styled from 'styled-components';

export const DateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 710px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 2rem;
  }
`;

export const FieldsContainer = styled.div`
  padding: 1.3rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;

  @media (max-width: 710px) {
    gap: 2rem;
  }
`;

export const FormStyle = styled.form`
  width: 30rem;
  padding: 1em 2em;
  @media (max-width: 710px) {
    width: 100%;
    padding: 0;
  }
`;

export const RequestFormStyled = styled.form`
  padding: 2rem;
`;
